export enum LocationSystem {
	EPSG25833 = 'EPSG:25833',
	EPSG25832 = 'EPSG:25832',
	EPSG4326 = 'EPSG:4326',
	EPSG4258 = 'EPSG:4258',
	EPSG3034 = 'EPSG:3034',
	EPSG3035 = 'EPSG:3035',
	EPSG3044 = 'EPSG:3044',
	EPSG3045 = 'EPSG:3045',
	EPSG3857 = 'EPSG:3857',
	EPSG4839 = 'EPSG:4839',
	EPSG5650 = 'EPSG:5650',
	EPSG4647 = 'EPSG:4647',
	// Gauß-Krüger Zonen
	EPSG31466 = 'EPSG:31466', // GK Zone 2
	EPSG31467 = 'EPSG:31467', // GK Zone 3
	EPSG31468 = 'EPSG:31468', // GK Zone 4
	EPSG31469 = 'EPSG:31469'  // GK Zone 5
}

export interface Location {
	system: LocationSystem;
	x: number;
	y: number;
}

export function roundToNumber(v?: number, digits = 2): number | undefined {
	if (!v && v !== 0) return;
	const pow = Math.pow(10, digits);
	return Math.round((v! + Number.EPSILON) * pow) / pow;
}
